export default __webpack_public_path__ + "3584ed818a2435d2d8c493c72c0e9505.svg";